// extracted by mini-css-extract-plugin
export default {"content":"Permit_content__fiHXQ","icon":"Permit_icon__egX80"};